import { M1ShiftReportPage } from "./M1ShiftReportPage";

const M1ShiftReport = () => {
	return <M1ShiftReportPage />;
};
export default M1ShiftReport;
